import { Component } from '@angular/core';
import { StartupService } from '../../core/service/startup.service';
import { StartupInfo } from '../../core/model/startup-info.model';
import {CONSTANTS_VALUE} from '../../config/constants.module';

@Component({
    selector: 'startup',
    templateUrl: './startup.component.html',
    styleUrls: ['startup.component.scss'],
    standalone: false
})
export class StartupComponent {
  public startupInfoList: StartupInfo[];
  APP_TITLE = CONSTANTS_VALUE.appTitle;

  constructor(public startupService: StartupService) {
    this.startupInfoList = this.startupService.startupInfoList;
  }
}
